var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card user-card"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container404"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("哎呀！您查找的页面不存在。")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }